<template>
  <v-row class="term__background pa-5">
    <v-col cols="12" class="term__wrapper">
      <v-row>
        <v-col cols="12" class="mt-0 mt-sm-10">
          <span class="title font-weight-black">TERMO DE CONDIÇÕES</span>
          <div class="term__box pa-5 pa-sm-10 pt-sm-7 pr-0 pr-sm-0 my-6">
            <h1 class="subtitle-1 mb-5 font-weight-bold">{{ termTitle }}</h1>
            <div class="term__text pr-5 pr-sm-10">
              <div v-html="termText" />
              <img class="mt-3"
                src="@/assets/logo_lockton_escuro.svg"
                alt="logo lockton"
                style="margin: 0 auto; display: flex;"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="9">
          <v-form ref="form">
            <v-checkbox
              v-model="accept"
              label="Declaro que li e estou ciente das condições acima"
              class="d-inline-block pr-5 ma-0 pt-0"
              color="secondary"
              dark
              dense
              :rules="[requiredInput]"
            />
          </v-form>
        </v-col>
        <v-col cols="12" sm="3" class="d-flex justify-end">
          <BaseButton
            v-html="'CONCLUIR'"
            color="secondary"
            @click="submit"
            block
          >
          </BaseButton>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { termText, termTitle } from "../components/text";
import { mapActions } from "vuex";
import { requiredInput } from "@/utils/rules";
import { LoadingRequest } from "@/mixins/LoadingMixin";

export default {
  name: "AcceptTerm",
  mixins: [LoadingRequest],
  data: () => ({
    termText,
    termTitle,
    accept: false,
    requiredInput
  }),
  methods: {
    ...mapActions("term", ["acceptTerm"]),
    submit() {
      if (this.$refs.form.validate()) {
        this.withLoading(this.acceptTerm())
          .then(() => this.$router.push({ name: "quotation" }))
          .catch(error => {
            this.showAlertNotification({
              message:
                !error.response || !error.response.data.details
                  ? "Não foi possível aceitar o termo de condições."
                  : error.response.data.details.reduce(
                      (acc, { message }) => acc.concat(message),
                      ""
                    ),
              type: "error"
            });
            this.$router.push({ name: "quotation" });
          });
      }
    }
  }
};
</script>

<style lang="sass">
.term
  &__background
    background-color: var(--v-darkBlue-base)
    color: white
  &__wrapper
    max-width: 800px
    margin: auto
  &__box
    background-color: white
    color: var(--v-primary-base)
    overflow: hidden
    box-sizing: border-box
  &__text
    overflow: auto
    height: 430px
    white-space: pre-line
</style>
